import React from 'react';

import {
  Grid,
} from '@material-ui/core';

import InputField from '../../common/components/inputField';
import * as asyncSelectData from '../../common/asyncSelectData';

import classes from '../../css/getCSS';


const requestForm = (props) => {
  return (
    <React.Fragment>
      <blockquote className={classes.profileFormQuote}>
        Are you sure you want to send a request to this candidate? <br />
        You can undo this action within 30 mins. <br />
        Note: You can only send 10 requests per day!
      </blockquote>
      <br /><br />
      <Grid container spacing={24}>
        <Grid item md={12} xs={12} sm={12}>
          <InputField
            id="options"
            config={props.inputs.options}
            changed={event => props.inputChangedHandler(event, 'options')}
            loadOptions={() => asyncSelectData.getOptionConstants('requestOptions')}
          />
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default requestForm;



// WEBPACK FOOTER //
// ./src/activities/components/requestForm.js